module.exports = __webpack_public_path__ + "static/media/pencil.309a73cf.svg";


//////////////////
// WEBPACK FOOTER
// ../thicket/packages/thicket-elements/images/pencil.svg
// module id = 99
// module chunks = 2